import { createStore } from 'vuex'
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

/**
 * Cart
 */
import cartState from './cart/state';
import cartGetters from './cart/getters';
import cartActions from './cart/actions';
import cartMutations from './cart/mutations';

export default createStore({
  state: {
    loggedIn: false,
    user: {
      name: null,
      email: null,
      password: null,
      uuid: null,
      city: null,
      status: null,
      profilePicture: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    },
    user_lang: 'pt',
    user_lang_name: 'português',
    dataChest: {},
    comboChest: {},
    cookiesAccepted: false,
    token: null,
    regeneratorCalled: false,
    requested_route: null,
    requested_route_query: null,
    calledRequests: [],
    isLogging: false,
    context: null,
    purchaseItems: []
  },
  getters,
  mutations,
  actions,
  modules: {
    cart: {
      namespaced: true,
      state: cartState,
      getters: cartGetters,
      actions: cartActions,
      mutations: cartMutations,
    },
  },
});